import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Sessão iniciada");
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Não foi possível iniciar sessão");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-[#F3F1EB] px-4 py-16"
    >
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 lg:p-10 border border-[#D4C4A8]/40">
        <div className="flex flex-col items-center mb-8">
          <div className="h-14 w-14 rounded-full bg-[#3A4A38] text-white flex items-center justify-center mb-4">
            <Lock size={24} />
          </div>
          <h1 className="text-2xl font-semibold text-[#2C2C2C]">Painel de Administração</h1>
          <p className="text-sm text-[#2C2C2C]/70 mt-1">Quinta da Oliveirinha</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#2C2C2C] mb-1">Email</label>
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="w-full px-4 py-3 rounded-md border border-[#D4C4A8] bg-[#F3F1EB]/50 focus:outline-none focus:ring-2 focus:ring-[#3A4A38] text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#2C2C2C] mb-1">Palavra-passe</label>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="w-full px-4 py-3 rounded-md border border-[#D4C4A8] bg-[#F3F1EB]/50 focus:outline-none focus:ring-2 focus:ring-[#3A4A38] text-sm"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-[#3A4A38] text-white font-medium text-sm hover:bg-[#2C3A2A] transition-colors disabled:opacity-60"
          >
            {submitting && <Loader2 size={16} className="animate-spin" />}
            {submitting ? "A entrar..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
